import { WhatsAppOutlined } from "@ant-design/icons";
import { FloatButton } from "antd";

const FloatingWhatsApp = () => {
  return (
    <FloatButton
      type="primary"
      style={{
        right: 24,
        bottom: 24,
      }}
      icon={<WhatsAppOutlined style={{ color: "#002753" }} />}
      href="https://wa.me/+60122506616"
      target="_blank"
    />
  );
};

export default FloatingWhatsApp;
